import { computed, defineComponent, onMounted, ref } from "vue";
import InputWidget from "./InputWidget";
import * as moment from "moment";

export default defineComponent({
    components: {
        InputWidget,
    },

    template: `
        <InputWidget :label="label" :required="required" class="InputDate">
            <input ref="ref_input" type="text" :value="valueformatted" class="InputDate__input" :required="required" readonly />
        </InputWidget>
    `,

    emits: [
        'update:modelValue',
    ],

    props: {
        modelValue: { type: Date },
        label: { type: String },

        min: { type: [Date, String] },
        onlyfirsts: { type: Boolean, default: false },

        required: { type: Boolean },
    },

    setup(props, ctx) {
        const value = ref(props.modelValue);
        const ref_input = ref(null);

        const valueformatted = computed(() => {
            if (props.modelValue) {
                return moment(props.modelValue).format('DD.MM.YYYY');
            } else {
                return null;
            }
        });

        function onChange(date: Date) {
            ctx.emit('update:modelValue', date);
        }

        onMounted(() => {
            const $input = $(ref_input.value);

            $input.datepicker({
                dateFormat: 'd.m.y',

                minDate: props.min,

                beforeShowDay: function (date) {
                    if (props.onlyfirsts) {
                        return [date.getDate() === 1, ""];
                    } else {
                        return [true, ""];
                    }
                },

                onSelect: (val) => {
                    onChange($input.datepicker('getDate'));
                },
            });
        });

        return {
            value,
            ref_input,

            valueformatted,

            onChange,
        };
    },
});
